<template>
  <div>
    <PostalCodeDetail type="new" :submitting="submitting" @submit="submit" />
  </div>
</template>

<script>
import { helper } from '@core/mixins/helper';
import PostalCodeDetail from '@/views/pages/postal_codes/PostalCodeDetail.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    PostalCodeDetail
  },
  mixins: [helper],

  data() {
    return {
      submitting: false
    };
  },

  async created() {
    await this.$store.dispatch('app/getCountries');
  },

  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .createPostalCode(data)
        .then(response => {
          this.$router.push('/postal_codes');
          this.showSuccessMessage(
            `${
              response.message ||
              (this.type === 'new'
                ? this.$t('Create Postal Code Success Message')
                : this.$t('Edit Postal Code Success Message'))
            }`
          );
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
